import React, { Component } from 'react';
import connect from "react-redux/es/connect/connect";
import {Redirect} from "react-router-dom";
import FlatButton from "material-ui/FlatButton";
import TextField from 'material-ui/TextField/TextField';
import { Card, CardActions } from "material-ui/Card";
import { NavigationArrowBack } from "material-ui/svg-icons";
import ExploreIcon from "material-ui/svg-icons/action/explore";

import * as utils from './utils';
import * as urls from "./urls";
import ViewTitle from "components/layout/ViewTitle";

import { getChainShopList, transferPrimary } from 'actions/advancedFunction';
import SelectInput from "components/input/SelectInput";
import { SimpleForm } from "components/form";
import { clearCrudResourceData, setSaving, showNotification } from "actions";


const cardActionStyle = {
  zIndex: 2,
  float: 'right',
};
class PremiumShopTransferPrimary extends Component {
  constructor(props) {
    super(props);
    this.goBack = this.goBack.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    const {currentSelectedShopData} = this.props;
    if (currentSelectedShopData) {
      this.props.dispatch(getChainShopList(currentSelectedShopData.shop_id));
    }
  }

  goBack() {
    this.props.dispatch(clearCrudResourceData(utils.PremiumShopResourceName));
    this.props.history.goBack();
  }

  makeSelectInputShopValue(currentChainShopList) {
    const {currentSelectedShopData} = this.props;
    if (!currentChainShopList) {
      return [];
    }
    const selectValues = [];
    for(let shop of currentChainShopList) {
      if (shop.shop_id === currentSelectedShopData.shop_id) {
        continue;
      }
      const selectValue = {};
      selectValue.value = shop.shop_id;
      selectValue.text = `${shop.shop_id} - ${shop.shop_info.shop_name}`;
      selectValues.push(selectValue);
    }
    return selectValues;
  }

  handleSubmit(record) {
    const {currentChainShopList} = this.props;
    for(let shop of currentChainShopList) {
      if (shop.shop_id === record.selectShopId && !shop.shop_info.owner_mobile_number) {
        this.props.dispatch(showNotification('Please link owner mobile before assigning the shop to primary shop', 'warning'));
        this.props.dispatch(setSaving(false));
        return ;
      }
    }
    const { selectShopId } = record;
    const data = {
      new_primary_shop_id: selectShopId,
    };
    this.props.dispatch(transferPrimary(data));
  }

  render() {
    const {currentSelectedShopData, currentChainShopList} = this.props;
    if (!currentSelectedShopData) {
      return (
        <Redirect to={urls.premiumShopFrontendPath} />
      );
    }
    const selectInputValue = this.makeSelectInputShopValue(currentChainShopList);

    return (
      <div className="list-page">
        <Card style={ {padding: '5px'} }>
          <CardActions style={cardActionStyle} >
            <FlatButton primary label={'Back'}
                        onClick={this.goBack}
                        icon={ <NavigationArrowBack />}
            />
          </CardActions>
          <ViewTitle title={`Transfer primary shop for ${currentSelectedShopData.shop_info.shop_name}`} />

          <div style={{padding: '20px'}}>
            <TextField floatingLabelText={'Chain ID'} value={currentSelectedShopData.chain_info.chain_id} />
            <br />
            <TextField floatingLabelText={'Current Primary Shop ID'} value={currentSelectedShopData.shop_id}/>
            <br />
            <TextField floatingLabelText={'Current Primary Shop Name'} value={currentSelectedShopData.shop_info.shop_name}/>
            <br />
            {
              selectInputValue && selectInputValue.length > 0 ?
                <SimpleForm submitButtonIcon={<ExploreIcon/>}
                            submitButtonLabel="Inquiry"
                            onSubmit={this.handleSubmit} >
                      <SelectInput optionValue='value'
                                   isRequired={true}
                                   source='selectShopId'
                                   optionText='text'
                                   choices={selectInputValue}
                                   label={'Shop list'}
                                   style={{marginLeft: '-1em'}}
                      />
                </SimpleForm>
                :
                <p>No Branch Available</p>
            }
          </div>
        </Card>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    currentSelectedShopData: state.admin.recordSelected[utils.PremiumShopResourceName],
    currentChainShopList: state.admin.advancedFunction.currentChainShopList,
  };
}
export default connect( mapStateToProps )(PremiumShopTransferPrimary);



// WEBPACK FOOTER //
// ./src/routes/advancedFunction/PremiumShopTransferPrimary.js